export const STANDARD_REPORTS  = "Standard Reports";
export const SERVICE_DOCUMENTS = "Service Documents";
export const OTHER_DOCUMENTS = "Other Documents";

export const DOCUMENT_CATEGORIES = [
    {
        id: 1,
        label: STANDARD_REPORTS,
        value: STANDARD_REPORTS
    },
    {
        id: 2,
        label: SERVICE_DOCUMENTS,
        value: SERVICE_DOCUMENTS
    },
    {
        id: 3,
        label: OTHER_DOCUMENTS,
        value: OTHER_DOCUMENTS
    }
];